export default __webpack_public_path__ + "static/media/placeholder.5dc71b4b.jpg";